<script setup>
</script>

<template>
    <th scope="col" class="text-sm font-medium text-gray-900 px-6 py-4"><slot/></th>
</template>

<style scoped>

</style>
